export class RailingColorElement {
  colors;
  selected;
  visible;
  productTypes = [];
  type;
  private defaults;

  constructor(defaults) {
    this.selected = false;
    this.defaults = defaults;
    this.visible = true;
  }

  setColors(colors) {
    this.colors = colors;
  }

  setSelectedColor(color) {
    this.selected = color;
  }

  setDefaultColor(colors) {
    this.selected = colors.find(color => color.name === this.defaults) || this.selected;
  }

  setCustomColor(color) {
    this.selected = color;
  }

  addProductType(productType: string) {
    if (!this.productTypes.includes(productType)) {
      this.productTypes.push(productType);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/custom/railingColorElement.ts